import {
  type ExternalLink,
  ProjectActions,
} from '@octopus-do/octopus-project-core'
import { commitProjectRequest } from '@storeOld/actionCreators'
import eq from 'fast-deep-equal'
import { useState } from 'react'
import type { DraggableData, DraggableEvent } from 'react-draggable'
import { useDispatch } from 'react-redux'

import { useDragToEdge, useScaleZoom } from '@/hooks'

type UseDraggable = {
  grid: [number, number]
  isDragging: boolean
  position?: { x: number; y: number }
  scale: number

  onStart: () => void
  onDrag: (e: DraggableEvent, data: DraggableData) => void
  onStop: (e: DraggableEvent, data: DraggableData) => void
}

const useDraggable = (link: ExternalLink): UseDraggable => {
  const [isDragging, setIsDragging] = useState(false)

  const dispatch = useDispatch()

  const { scale } = useScaleZoom()
  const dragToEdge = useDragToEdge(isDragging)

  const onStart = () => {}

  const onDrag = (event: DraggableEvent, _data: DraggableData) => {
    setIsDragging(true)

    dragToEdge(event as React.MouseEvent<HTMLDivElement, MouseEvent>)
  }

  const onStop = (e: DraggableEvent, data: DraggableData) => {
    setIsDragging(false)

    if (!eq({ x: data.x, y: data.y }, link.offset)) {
      e.stopPropagation()
    } else {
      return
    }

    if (link) {
      dispatch(
        commitProjectRequest(
          ProjectActions.externalLinks.updateOffset({
            id: link.id,
            offset: { x: data.x, y: data.y },
          })
        )
      )
    }
  }

  return {
    isDragging,
    onStart,
    onDrag,
    onStop,
    grid: [3, 3],
    position: link.offset,
    scale,
  }
}

export default useDraggable
